import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Typography,
} from 'antd';
import getQueryParams from 'utils/getQueryParams';
import { cancelarRestablecerContrasena } from 'api/usuarios/auth';
import Card from './components/Card';
import './index.scss';

const { Text } = Typography;

const CancelarRestablecerContrasena = () => {
  const history = useHistory();
  const [respuesta, setRespuesta] = useState([]);

  useEffect(() => {
    let mounted = true;
    const verify = async () => {
      const codigo = getQueryParams('codigo', window.location.href);
      if (!codigo) {
        history.push('/');
      }
      const cancelled = await cancelarRestablecerContrasena(codigo);
      if (mounted) {
        setRespuesta(cancelled
          ? 'Se canceló con exito la petición para restablecer la contraseña'
          : 'Lo sentimos. Ha ocurrido un proceso inesperado, vuelva a intentarlo.');
      }
    };
    verify();
    return () => { mounted = false; };
  }, []);

  return (
    <Card>
      <Text style={{ textAlign: 'center' }}>
        {respuesta}
      </Text>
      <br />
      <Button
        style={{
          width: '150px',
        }}
        className="auth-button"
        onClick={() => history.push('/')}
      >
        Continuar
      </Button>
    </Card>
  );
};

export default CancelarRestablecerContrasena;
